
import React from 'react';
export default (props) => {
   
        return (
           <img
                alt="Foto"
                width={props.width}
                height={props.height}
                className={props.className}
                src={props.src}
            />
        );
}




// WEBPACK FOOTER //
// ./src/container/renderFotoPerfil.js